import React from "react";
import { t } from "locales";
import useModalLinkPrinter from "hooks/useModalLinkPrinter";
import BaseButton from "components/BaseButton";
import BaseIcon from "components/BaseIcon";
import FullWidthPageBackground from "components/FullWidthPageBackground";
import "./style.scss";

export default function BlockBecomeACoach() {
  const { getLocation } = useModalLinkPrinter();
  return (
    <div className="block-become-a-coach text-center">
      <FullWidthPageBackground className="block-become-a-coach__background" />
      <div className="block-become-a-coach__content d-flex __column __align-center">
        <h2 className="h2 fw-bold text-center mb-4">{t("Interested in becoming a Secure The Offer coach?")}</h2>
        <div className="subtitle-1 fw-semibold text-center mb-5">
          {t("Join our trusted network of industry professionals")}
        </div>

        <BaseButton
          className="block-become-a-coach__btn body-big fw-bold pl-4 pr-3"
          to={getLocation("/signup/coach")}
          large
          borderless
        >
          {t("Become a Coach")}
          <BaseIcon className="f-shrink-0 ml-2">chevron-right</BaseIcon>
        </BaseButton>
      </div>
    </div>
  );
}
